export function toCurrency(value: any): string {
  try {
    const ret = value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
    return ret;
  } catch (e) {
    return 'NaN'
  }
}
